import React from 'react';
import { ADMIN_WA, WAIcon } from './academyUtils';

export default function BookTeacher({ onBack }) {
  function openWA() {
    const msg = 'Hello Mr. Ahmed Salem! I would like to book lessons with Compass Academy. Please help me get started.';
    window.open(`https://wa.me/${ADMIN_WA}?text=${encodeURIComponent(msg)}`, '_blank');
  }

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(135deg,#f0f4f8,#e4ecf7)', display:'flex', alignItems:'center', justifyContent:'center', padding:20, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      <div style={{ maxWidth:460, width:'100%' }}>
        <div style={{ textAlign:'center', marginBottom:20 }}>
          <img src="/logo.png" alt="IELTS Compass" style={{ height:48, objectFit:'contain' }}/>
        </div>
        <div style={{ background:'#fff', border:'1px solid #dde3ed', borderRadius:16, padding:36, boxShadow:'0 6px 28px rgba(26,42,74,0.10)', textAlign:'center' }}>
          <div style={{ fontSize:52, marginBottom:16 }}>🎓</div>
          <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:26, fontWeight:700, color:'#1a2a4a', marginBottom:10 }}>
            Ready to start learning?
          </div>
          <div style={{ fontSize:14, color:'#5a6a88', lineHeight:1.75, marginBottom:24 }}>
            Contact Mr. Ahmed Salem on WhatsApp. He will assess your level, match you with the most suitable teacher for your goals, and set up your personalised learning plan.
          </div>

          <div style={{ background:'#f7f9fc', border:'1px solid #dde3ed', borderRadius:10, padding:'14px 18px', marginBottom:24, textAlign:'left' }}>
            {[
              '📝 Take the free Placement Test to find your level',
              '👩‍🏫 Get matched with the right teacher for your goals',
              '📅 Receive your teacher\'s available schedule',
              '✅ Confirm your booking directly with Mr. Ahmed',
            ].map((s,i)=>(
              <div key={i} style={{ fontSize:13.5, color:'#2a3a5a', lineHeight:1.6, marginBottom:i<3?8:0 }}>{s}</div>
            ))}
          </div>

          <button onClick={openWA}
            style={{ width:'100%', background:'#25d366', color:'#fff', border:'none', padding:'15px 0', borderRadius:10, fontSize:15, fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:10, boxShadow:'0 3px 14px rgba(37,211,102,0.35)', marginBottom:14 }}>
            <WAIcon size={18}/> Contact Mr. Ahmed Salem
          </button>

          <button onClick={onBack}
            style={{ background:'none', border:'none', color:'#9aa3b8', fontSize:12, cursor:'pointer', fontFamily:"'JetBrains Mono',monospace" }}>
            ← Back
          </button>
        </div>
      </div>
    </div>
  );
}
